import React, {useImperativeHandle, forwardRef} from 'react';
import './finances-form.sass';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Input, InputSize } from '../../../../components/interface/input/input';
import { useDispatch, useSelector } from 'react-redux';
import { createInvoiceData } from '../../configuration.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { getTeamVendorId } from '../../../login/session.slice';

const FormSchema = Yup.object().shape({
    invoiceName: Yup.string().required('Pole wymagane!'),
    invoiceAddress: Yup.string().required('Pole wymagane!'),
    invoicePostalCode: Yup.string().required('Pole wymagane!'),
    invoiceCity: Yup.string().required('Pole wymagane!'),
    invoiceNip: Yup.string().matches('^\\d+$', 'Nip nieprawidłowy!')
        .min(10, 'Za krótkie!')
        .max(10, 'Za długie')
        .required('Pole wymagane!')
});
/* eslint-disable react/display-name */
export const FinancesForm = forwardRef(({onSuccess}, ref) => {

    const dispatch = useDispatch();
    const sessionData = useSelector(state => state.session);

    const vendorId = getTeamVendorId(sessionData);

    const formik = useFormik({
        initialValues: {
            invoiceName: '',
            invoiceAddress: '',
            invoicePostalCode: '',
            invoiceCity: '',
            invoiceNip: '',
        },
        validationSchema: FormSchema,
        onSubmit: (values) => {
            dispatch(createInvoiceData({...values, id: vendorId}))
                .then(unwrapResult)
                .then(() => {
                    toast.success('formularz wysłany');
                    onSuccess();
                }, () => {
                    toast.error('coś poszło nie tak');
                })
                .catch(e => {
                    toast.error(e.message);
                });
        }
    });

    const startFn = () => {
        formik.submitForm();
    };

    useImperativeHandle(ref, () => ({
        start:  startFn
    }));

    return (
        <div ref={ref} className='vv-vendor-finances-form-container'>
            <form>
                <div className='vv-vendor-finances-form'>
                    <div className='vv-vendor-finances-form-container__left'>
                        <div className='vv-vendor-finances-form-container__input-margin-bottom'>
                            <Input label='Nazwa firmy' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='invoiceName' id='invoiceName'
                                   value={formik.values.invoiceName}
                                   textError={formik.touched.invoiceName && formik.errors.invoiceName}/>
                        </div>
                        <div className='input-postal-code-city-container'>
                            <div className='vv-vendor-finances-form-container__input-margin-right'>
                                <Input label='Kod pocztowy' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                       name='invoicePostalCode' id='invoicePostalCode'
                                       value={formik.values.invoicePostalCode}
                                       textError={formik.touched.invoicePostalCode && formik.errors.invoicePostalCode}
                                       inputSize={InputSize.SMALL}/>
                            </div>
                            <Input label='Miasto' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='invoiceCity' id='invoiceCity'
                                   value={formik.values.invoiceCity}
                                   textError={formik.touched.invoiceCity && formik.errors.invoiceCity}
                                   inputSize={InputSize.SMALL}/>
                        </div>
                    </div>
                    <div className='vv-vendor-finances-form-container__right'>
                        <div className='vv-vendor-finances-form-container__input-margin-bottom'>
                            <Input label='Adres' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='invoiceAddress' id='invoiceAddress'
                                   value={formik.values.invoiceAddress}
                                   textError={formik.touched.invoiceAddress && formik.errors.invoiceAddress}/>
                        </div>
                        <Input label='NIP' onBlur={formik.handleBlur} onChange={formik.handleChange}
                               name='invoiceNip' id='invoiceNip'
                               value={formik.values.invoiceNip}
                               textError={formik.touched.invoiceNip && formik.errors.invoiceNip}/>
                    </div>
                </div>
            </form>
        </div>
    );
});
